var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ThrowError"},[_c('button',{on:{"click":_vm.generateError}},[_vm._v("Generate error")])])}
var staticRenderFns = []

export { render, staticRenderFns }